import { createContext, useContext, useState } from "react";

const BookingContext = createContext(null);

export function BookingProvider({ children }) {
  const [state, setState] = useState({
    step: 0,
    service: null,
    location: null,
    slot: null,
    slotClinicianId: null,    // Aerona clinician id of the picked slot (multi-calendar support)
    patient: {
      first_name: "",
      last_name: "",
      phone: "",
      phone_country: "+353",
      email: "",
      notes: "",
      aerona_patient_id: null,
      force_new_patient: false,
    },
    payOnline: true,
    bookingId: null,
    paymentUrl: null,
  });

  const update = (patch) => setState((p) => ({ ...p, ...patch }));
  const setPatient = (patch) => setState((p) => ({ ...p, patient: { ...p.patient, ...patch } }));
  const next = () => setState((p) => ({ ...p, step: p.step + 1 }));
  const back = () => setState((p) => ({ ...p, step: Math.max(0, p.step - 1) }));
  const goTo = (step) => setState((p) => ({ ...p, step }));
  const setConflict = (msg) => setState((p) => ({ ...p, step: 1, conflictMessage: msg, slot: null, slotClinicianId: null }));
  const reset = () => setState({
    step: 0, service: null, location: null, slot: null, slotClinicianId: null,
    patient: { first_name: "", last_name: "", phone: "", phone_country: "+353", email: "", notes: "", aerona_patient_id: null, force_new_patient: false },
    payOnline: true, bookingId: null, paymentUrl: null,
  });

  return (
    <BookingContext.Provider value={{ ...state, update, setPatient, next, back, goTo, reset, setConflict }}>
      {children}
    </BookingContext.Provider>
  );
}

export const useBooking = () => {
  const ctx = useContext(BookingContext);
  if (!ctx) throw new Error("useBooking must be used within BookingProvider");
  return ctx;
};

// Step list adapts: when service is free, Payment step is skipped.
// Step 4 is labelled "Confirm" on the Clinic site (not "Payment") so
// customers don't fear a mandatory charge before reaching Step 4 — they
// still get the pay-online option there, but "pay at clinic" is
// equally valid.
export function buildSteps(isPaid) {
  const step4Label = (typeof window !== "undefined" && /whitesmileclinic/i.test(window.location.hostname))
    || (typeof window !== "undefined" && new URLSearchParams(window.location.search).get("site") === "clinic")
    ? "Confirm"
    : "Payment";
  return isPaid
    ? [
        { id: 0, label: "Service" },
        { id: 1, label: "Time" },
        { id: 2, label: "Details" },
        { id: 3, label: step4Label },
        { id: 4, label: "Done" },
      ]
    : [
        { id: 0, label: "Service" },
        { id: 1, label: "Time" },
        { id: 2, label: "Details" },
        { id: 3, label: "Done" },
      ];
}
